import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';

import {
  Section,
  TextContainer,
  TextContent,
  Title,
  Description,
  ImageContainer,
  ButtonContainer,
  Button,
} from './EducationSection.style';

/**
 * 「SEMINAR」(右に画像、左に説明文と「セミナー情報のご案内」ボタン) 表示部分
 */
const EducationSection = ({
  color,
  description,
  entryId,
  image,
  index,
  linkExternal,
  linkLabel,
  linkUrl,
  locale,
  title,
}) => (
  <Section color={color ? 1 : 0} index={index} id={entryId}>
    <ImageContainer>
      {image ? <Image src={image} options={{ size: 600, w: '100%' }} /> : <Placeholder w="100%" pb="calc(250% / 3)" />}
    </ImageContainer>
    <TextContainer>
      <TextContent>
        <Title color={color ? 1 : 0}>{title || <Placeholder w="80%" pb="15%" />}</Title>
        <Description color={color ? 1 : 0}>{description || <Placeholder w="100%" pb="18%" />}</Description>

        {linkUrl &&
          linkLabel &&
          linkExternal && (
            <ButtonContainer>
              <a href={linkUrl} target="_blank">
                <Button>{linkLabel}</Button>
              </a>
            </ButtonContainer>
          )}
        {linkUrl &&
          linkLabel &&
          !linkExternal && (
            <ButtonContainer>
              <Link href={`/${locale}${linkUrl}`} to={`/${locale}${linkUrl}`}>
                {/* 「セミナー情報のご案内」ボタン */}
                <Button>{linkLabel}</Button>
              </Link>
            </ButtonContainer>
          )}
      </TextContent>
    </TextContainer>
  </Section>
);

EducationSection.defaultProps = {
  color: false,
  description: undefined,
  entryId: undefined,
  image: undefined,
  linkExternal: undefined,
  linkLabel: undefined,
  linkUrl: undefined,
  title: undefined,
};

EducationSection.propTypes = {
  color: PropTypes.bool,
  description: PropTypes.string,
  entryId: PropTypes.string,
  image: PropTypes.shape(),
  index: PropTypes.number.isRequired,
  linkExternal: PropTypes.bool,
  linkLabel: PropTypes.string,
  linkUrl: PropTypes.string,
  locale: PropTypes.string.isRequired,
  title: PropTypes.string,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(EducationSection);



// WEBPACK FOOTER //
// ./src/pages/EducationPage/EducationSection/EducationSection.js